var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#FBF8FF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 27.5V25.8333C26.6663 24.9493 26.3152 24.1014 25.69 23.4763C25.0649 22.8512 24.2171 22.5 23.333 22.5H16.6663C15.7823 22.5 14.9344 22.8512 14.3093 23.4763C13.6842 24.1014 13.333 24.9493 13.333 25.8333V27.5M23.333 15.8333C23.333 17.6743 21.8406 19.1667 19.9997 19.1667C18.1587 19.1667 16.6663 17.6743 16.6663 15.8333C16.6663 13.9924 18.1587 12.5 19.9997 12.5C21.8406 12.5 23.333 13.9924 23.333 15.8333Z",
    stroke: "#223CDD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.4f8f82cfe4547be75ac4148c1afc0df9.svg";
export { ForwardRef as ReactComponent };